<template>
    <div class="container-fluid">
        <h1>{{ $t('menuItemLinks') }}</h1>
        <br />
        <div class="row">
            <!-- Search field -->
            <search-box
                id="searchConnections"
                @input="$_onInput"
                :info="$t('searchInfo')"
                :autofocus="true"
                :value="searchText"
                :saveInState="true"
            >
            </search-box>
            <b-link class="px-1 pt-2" @click="$_clearFilters()">
                {{ $t('clearFilter') }}
            </b-link>
        </div>
        <!-- No content for overview -->
        <div v-show="noData" class="col-md-12">
            <span>{{ $t('connectionsNonePresent') }}</span>
        </div>
        <br />
        <div>
            <b-table
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoaded"
                @row-clicked="$_onDetails"
                :tbody-tr-class="$_rowClass"
                :items="filteredRecords"
                :fields="fields"
                :sort-by.sync="sortBy"
                sort-icon-left
            >
            </b-table>
        </div>
    </div>
</template>

<script>
    /* Store imports */
    import { orderBy } from 'lodash';
    import { INPUT_TYPE, URL_CONNECTION_TYPE } from '../../constants';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import SearchBox from '../../components/SearchBox.vue';

    export default {
        mixins: [modalMixin],
        components: { 'search-box': SearchBox },

        data() {
            return {
                // Constants
                noData: true,
                allConnectionLicenses: [],
                // table fields
                fields: [
                    {
                        key: 'urlConnectionLicense.type',
                        label: this.$t('columnTypeTitle'),
                        sortable: true,
                        thStyle: { border: 0 },
                        formatter: (value) => {
                            return this.$_getTypeLabel(value);
                        }
                    },
                    {
                        key: 'urlConnectionLicense.name',
                        label: this.$t('columnNameName'),
                        sortable: true,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'linkText',
                        label: this.$t('columnLinkText'),
                        sortable: true,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'available',
                        label: this.$t('labelAvailable'),
                        sortable: true,
                        tdClass: 'width-10',
                        formatter: (value) => (value ? this.$t('btnTitleYes') : '')
                    }
                ],
                sortBy: 'urlConnectionLicense.type',
                searchText: ''
            };
        },

        computed: {
            dataLoaded() {
                return this.allConnectionLicenses.length > 0;
            },

            /*
             * filter records on TYPE, NAME and URL
             */
            filteredRecords() {
                let records = this.allConnectionLicenses;
                const searchVal = this.searchText;
                if (searchVal && searchVal.length > 0) {
                    const tokens = searchVal.toLowerCase();
                    records = records.filter((record) => {
                        return (
                            record.urlConnectionLicense.name
                                .toLowerCase()
                                .includes(tokens) ||
                            record.linkText.toLowerCase().includes(tokens) ||
                            this.$_getTypeLabel(record.urlConnectionLicense.type)
                                .toLowerCase()
                                .includes(tokens)
                        );
                    });
                }
                return orderBy(records, [
                    (o) => o.urlConnectionLicense.name.toLowerCase()
                ]);
            }
        },

        mounted() {
            this.$_getAllocatedLinks();
        },

        methods: {
            /**
             * Gets the type label based on the connection type
             * @param connectionType
             */
            $_getTypeLabel(connectionType) {
                if (connectionType === URL_CONNECTION_TYPE.StreetView) {
                    return this.$t('streetView');
                } else if (connectionType === URL_CONNECTION_TYPE.Others) {
                    return this.$t('others');
                }
                return '-';
            },

            /*
             * Gets all available url connection licenses
             */
            async $_getAllocatedLinks() {
                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetOrganizationUrlConnectionSettings'
                    });
                    result?.data.forEach((item) => {
                        item.deleted = false;
                        item.edit = false;
                        item.inputType = INPUT_TYPE.Password;
                    });
                    this.noData = result?.data && result?.data.length === 0;
                    this.allConnectionLicenses = Object.assign([], result?.data);
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: this.$t('errorRetrievingConnections'),
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                }
            },

            $_onDetails(record) {
                this.$router.push({
                    path: `/dashboard/connections/detail/${record.id}`
                });
            },

            /*
             * Returns the class for tabel
             */
            $_rowClass() {
                return 'tablerow';
            },

            $_onInput(searchText) {
                this.searchText = searchText;
            },

            $_clearFilters() {
                this.$_onInput('');
            }
        }
    };
</script>
